// extracted by mini-css-extract-plugin
export default {"icon":"Settings-module__icon--r3pmV"};